
export const formatDateHeader = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();

    const isSameDay = (d1, d2) => 
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()

    // Today
    if (isSameDay(date, today)) return "Today";

    // Yesterday
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (isSameDay(date, yesterday)) return "Yesterday";

    // Other Date
    return date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric"
    })
}


export const formatDateChat = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();

    const isSameDay = (d1, d2) => 
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()

    if (isSameDay(date, today)) {
        return date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit"
        })
    }
        // Yesterday
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (isSameDay(date, yesterday)) return "Yesterday";

    // Other Date
    return date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric"
    })
    
}